import { render, staticRenderFns } from "./select-number-list.vue?vue&type=template&id=3c880953"
import script from "./select-number-list.vue?vue&type=script&lang=js"
export * from "./select-number-list.vue?vue&type=script&lang=js"
import style0 from "./select-number-list.vue?vue&type=style&index=0&id=3c880953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports